import { render, staticRenderFns } from "./Page404Layout.vue?vue&type=template&id=169382fe&scoped=true"
import script from "./Page404Layout.vue?vue&type=script&lang=js"
export * from "./Page404Layout.vue?vue&type=script&lang=js"
import style0 from "./Page404Layout.vue?vue&type=style&index=0&id=169382fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169382fe",
  null
  
)

export default component.exports